module.exports = [
  {
    slug: "/security",
    bgImage: require('../assets/06_Security/DAIF_Extra1_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/06_Security/06_DAIF_Security_01.mp4'),
    videoBgLoop: require('../assets/06_Security/06_DAIF_Security_01_loop.mp4'),
    bgImage2: require('../assets/06_Security/DAIF_Extra1_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/security/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/security/1",
    bgImage: require('../assets/06_Security/DAIF_Extra1_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/06_Security/06_DAIF_Security_02.mp4'),
    videoBgLoop: require('../assets/06_Security/06_DAIF_Security_02_loop.mp4'),
    bgImage2: require('../assets/06_Security/DAIF_Extra1_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/security",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  
]